import React, { Component } from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor } from "react-icons/fi";
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../translations";

class ServiceTwo extends Component{
    static contextType = LanguageContext;

    render(){
        const { language } = this.context;
        const t = translations[language];

        const ServiceList = [
            {
                icon: <FiCast />,
                title: t.homepage.services.items[0].title,
                description: t.homepage.services.items[0].description
            },
            {
                icon: <FiLayers />,
                title: t.homepage.services.items[1].title,
                description: t.homepage.services.items[1].description
            },
            {
                icon: <FiUsers />,
                title: t.homepage.services.items[2].title,
                description: t.homepage.services.items[2].description
            },
            {
                icon: <FiMonitor />,
                title: t.homepage.services.items[3].title,
                description: t.homepage.services.items[3].description
            }
        ];

        let title = t.homepage.services.title,
        description = t.homepage.services.description;
        return(
            <React.Fragment>
                <div className="row">
                    <div className="col-lg-6 m-auto text-center col-12">
                        <div className="section-title mt--30 mt_md--5 mt_mobile--5 mb_mobile--10 text-center">
                            <span className="subtitle theme-gradient text-center">{t.homepage.services.subtitle}</span>
                            <h2 className="title text-center">{title}</h2>
                            <p className="text-center">{description}</p>
                            <div className="service-btn text-center">
                                <a className="btn-transparent rn-btn-dark mb-4" href="/service"><span className="text">{t.homepage.services.button}</span></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 col-12 mt_md--50">
                        <div className="row service-one-wrapper">
                            {ServiceList.map( (val , i) => (
                                <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-4" key={i}>
                                    {/* <a href="/service-details"> */}
                                 
                                        <div className="service service__style--2">
                                            <div className={language=== 'ar' ? "icon ml-3" : "icon"}>
                                                {val.icon}
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{val.title}</h3>
                                                <p>{val.description}</p>
                                            </div>
                                        </div>
                                  
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceTwo;
